'use client';

import { SearchScrollTopButton } from '@packages/search/src/components/SearchScrollTopButton/SearchScrollTopButton';
import { SearchScrollTopAutoHideButton } from '@packages/search/src/components/SearchScrollTopAutoHideButton/SearchScrollTopAutoHideButton';
import { useFeatureFlag } from '@packages/search/src/utils/featureFlags/useFeatureFlag';
import { filterSettingsFab } from '@packages/search/src/activeFeatureFlags';

export const SearchScrollTopButtonClient = () => {
  const hasFilterSettingsFab = useFeatureFlag(filterSettingsFab);

  return hasFilterSettingsFab ? <SearchScrollTopAutoHideButton /> : <SearchScrollTopButton />;
};
